import {Utils} from "../../../common/utils";
import useSWR from "swr";
import {StandardResponse} from "@/types/swr";
import {Report} from "Stores/reportStore";

const clientConfigs = Utils.getEAIClientConfigs();

export function useReports() {
    const {data, mutate} = useSWR<StandardResponse<Report[]>, Error>(`${clientConfigs.baseUrl}/reports`);

    return {
        data: data?.data,
        mutate
    };
}
